export const NETWORK_LABELS: Record<string, string> = {
  BTC: "Bitcoin Network",
  EVM: "Ethereum (ERC-20)",
  BSC: "Binance Smart Chain (BEP-20)",
  TRON: "Tron (TRC-20)",
};
